const disableCloseEvent = (
  event: BeforeUnloadEvent,
) => {
  event.preventDefault();
};

export default disableCloseEvent;